import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Vendedor } from './vendedor';

@Injectable({
  providedIn: 'root'
})
export class VendedorService {


  constructor(private http: HttpClient) { }

 
  getVendedores(idEmisor: string) {  
    
    return this.http.get<Vendedor[]>(environment.apiUrl+"/listarVendedores/?idEmisor=" + idEmisor);  
  }  

  getVendedor(id:string) {  
  
    return this.http.get<Vendedor[]>(environment.apiUrl+"/buscarVendedorPorId/?id="+id);  
  }  


  setActulizarVendedor(Vendedores: Vendedor[]){
    console.log(Vendedores);
    return this.http.put<string>(environment.apiUrl+"/actulizarVendedores",Vendedores);
  }

  eliminarVendedor(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarVendedores/?id="+id);
  }
  




}
